import { FormHandles, SubmitHandler } from "@unform/core";
import React, { useContext, useRef, useState } from "react";
import Logo from "../../../assets/imgs/logos/2025/alumisoft.svg";
import api from "../../../services/api";

import { Input } from "../../../components/Form";

import { Form } from '@unform/web'
import * as Yup from 'yup'
import getValidationErrors from "../../../helpers/getValidateErrors";
import { getSingleErrorMessage } from "../../../helpers/getSingleErrorMessage";

import { ToastContext } from "../../../contexts/toast/toastContext";
import { ISolicitarAcesso } from "../../../common/interfaces/solicitarAcesso.interfaces";
import { BsArrowCounterclockwise } from "react-icons/bs";

const EsqueceuSuaSenha: React.FC = () => {

  // Refs
  const formRef = useRef<FormHandles>(null);

  //Context
  const toastContext = useContext(ToastContext);

  //States
  const [loading, setLoading] = useState(false);

  //Handles
  const hundleRecuperarSenha: SubmitHandler<ISolicitarAcesso> = async (solicitarAcesso) => {
    try {
     
      setLoading(true);
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        email: Yup.string().email('Digite um e-mail válido.').required('O e-mail é obrigatório.'),
      });

      await schema.validate(solicitarAcesso, { abortEarly: false });
      await api.post(`/acesso/recuperar-senha`, solicitarAcesso);

      formRef.current?.clearField("email");
      toastContext.notification("Enviamos um e-mail para você redefinir sua senha", "info");
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        formRef.current?.setErrors(getValidationErrors(err));
      }
      else {
        const message = getSingleErrorMessage(err);
        if (message) {
          toastContext.notification(message, "warn");
        } else {
          toastContext.notification(
            "Ocorreu um erro ao realizar essa operação.",
            "error"
          );
        }
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Form className="card" style={{ height: '100vh' }} ref={formRef} onSubmit={hundleRecuperarSenha}>
      <div className="flex-fill d-flex flex-column justify-content-center py-4">
        <div className="container-tight py-6">
          <div className="text-center mb-4 mt-4">
            <a href="/">
              <img src={Logo} height="40" alt="" />
            </a>
          </div>
          <div className="card card-md">
            <div className="card-body">
              <h2 className="card-title text-center mb-3">
                Esqueceu sua senha?
              </h2>
              <p className="text-center pt-3 pb-3">
                Insira seu e-mail no campo abaixo.
                <br/>Você receberá as instruções para redefinir sua senha.
              </p>
              <div className="mb-3">
                <label className="form-label">E-mail</label>
                <Input
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder="E-mail..."
                />
              </div>
              <div className="form-footer">
                <button type="submit" className={"btn btn-primary btn-block" + (loading ? " disabled" : "")}>
                  {loading ? "PROCESSANDO..." : "SOLICITAR SENHA"}
                  <BsArrowCounterclockwise className="ml-2"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default EsqueceuSuaSenha;
